<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <div>
        <i class="pi pi-tags title-card-icon"></i>
      </div>
      <div>
        <p class="mb-0 text-3xl title">{{'menu.groups' | transloco}}</p>
        <p>{{'menu.descriptions.groups' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
            </div>
            <div class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
          </div>
        </div>
        <p-table (onLazyLoad)="onPageChange($event)" [(first)]="first" [(rows)]="rows" [lazy]="true" [paginator]="true"
                 [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="totalGroups" [value]="groups"
                 styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.color' | transloco}}</th>
              <th scope="col">{{'attribute.groupName' | transloco}}</th>
              <th scope="col">{{'attribute.machineNumber' | transloco}}</th>
              <th scope="col" class="w-10rem"></th>
            </tr>
          </ng-template>
          <ng-template let-group pTemplate="body">
            <tr *ngIf="!loadingGroups">
              <td>
                <div class="flex flex-column">
                  <label [style.background-color]="group.color" readonly class="theme-picker">
                    <input [(ngModel)]="group.color" disabled type="color">
                  </label>
                  <p class="text-right md:text-left">{{group.color}}</p>
                </div>
              </td>
              <td>{{group.name}}</td>
              <td>{{group.totalMachines | number: '' : this.language}}</td>
              <td>
                <div class="flex justify-content-end">
                  <button
                    [routerLink]="group.machineGroupUuid + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    (click)="confirmAndDelete(group)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingGroups">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalGroups == 0"
                 class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
            <div *ngIf="totalGroups > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalGroups ? totalGroups : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalGroups}}
              {{(totalGroups > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.groupName' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          appAutoFocus
          pInputText
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="serialNumbers">{{'attribute.serialNumber' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect
          [(ngModel)]="currentFilters.serialNumbers"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body"
          [options]="machines"
          id="serialNumbers"
          optionLabel="serial"
          optionValue="serial"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
            currentFilters.name ||
            currentFilters.serialNumbers
          )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false; applyFilters()"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
